import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
	return (
		<textarea className={cn("control-field flex min-h-24 resize-y py-2", className)} {...props} />
	);
}
